import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import AdminSidebar from './Layout/AdminSidebar';
import StaffSidebar from './Layout/StaffSidebar';
import MemberSidebar from './Layout/MemberSidebar';
import SuperAdminSidebar from './Layout/SuperAdminSidebar';

/**
 * A wrapper component that renders the appropriate sidebar based on user role
 * This prevents staff from accessing admin sidebars and vice versa
 */
const RoleBasedSidebar = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Check if the current path doesn't match the user's role
  const currentPath = location.pathname;
  const userRolePrefix = `/${user.role.toLowerCase()}`;
  
  // If we're on a detailed page (like viewing a member) and the path prefix doesn't match the user's role,
  // we need to ensure we're using the correct sidebar
  if (currentPath.startsWith('/admin/') && user.role === 'staff') {
    // We're on an admin path but should be on a staff path
    console.log(`User role is ${user.role} but path is ${currentPath}, using StaffSidebar`);
    return <StaffSidebar>{children}</StaffSidebar>;
  }

  // Return the appropriate sidebar based on user role
  switch (user.role) {
    case 'superadmin':
      return <SuperAdminSidebar>{children}</SuperAdminSidebar>;
    case 'admin':
      return <AdminSidebar>{children}</AdminSidebar>;
    case 'staff':
      return <StaffSidebar>{children}</StaffSidebar>;
    case 'member':
      return <MemberSidebar>{children}</MemberSidebar>;
    default:
      return <MemberSidebar>{children}</MemberSidebar>;
  }
};

export default RoleBasedSidebar;
